export const PageSize = {
	Default: 25,
	Max: 200,
	Min: 1,
} as const;
